import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

import { useTranslate } from "@/composables";

interface CreatorSpotlightItem {
  sources: {
    xs: string;
    lg: string;
    fallback: string;
  };
  poster: string;
  label: string;
  title: string;
  description: string;
  action: string;
  cta: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatorSpotlight',
  setup(__props) {

const { t } = useTranslate();

const items = computed<Readonly<CreatorSpotlightItem[]>>(() => [
  {
    sources: {
      xs: "/videos/home/spotlight/home/xs.webm",
      lg: "/videos/home/spotlight/home/lg.webm",
      fallback: "/videos/home/spotlight/home/fallback.mp4",
    },
    poster: "/videos/home/spotlight/posters/home/lg.webp",
    label: t(
      "The Following Tab in the LTK app showcases Daily Drop videos, Recently Viewed products, and posts from Creators the user follows.",
    ).value,
    title: t("Connect with Creators you follow").value,
    description: t("Stay up to date with the Creators you know and love — all in one place.").value,
    action: t("Check it out").value,
    // edit link functionality here https://dashboard.branch.io/quick-links/qlc/config/1446900774042047148?editing=true&v=latest&step=general
    cta: "https://ltk.app.link/6b3FzG3Y2Sb",
  },
  {
    sources: {
      xs: "/videos/home/spotlight/discover/xs.webm",
      lg: "/videos/home/spotlight/discover/lg.webm",
      fallback: "/videos/home/spotlight/discover/fallback.mp4",
    },
    poster: "/videos/home/spotlight/posters/discover/lg.webp",
    label: t("Search for Resort Wear on LTK's Discover Tab to find relevant fashion recommendations from LTK Creators.")
      .value,
    title: t("Find products, brands, & Creators").value,
    description: t("Browse over 450 million products, 8,000 brands, and hundreds of thousands of global Creators.")
      .value,
    action: t("Discover more").value,
    // edit link functionality here https://dashboard.branch.io/quick-links/qlc/config/1446900905089173700?editing=true&v=latest&step=link-data
    cta: "https://ltk.app.link/AfroCZ5Y2Sb",
  },
  {
    sources: {
      xs: "/videos/home/spotlight/watch/xs.webm",
      lg: "/videos/home/spotlight/watch/lg.webm",
      fallback: "/videos/home/spotlight/watch/fallback.mp4",
    },
    poster: "/videos/home/spotlight/posters/watch/lg.webp",
    label: t(
      "Near You section on the Watch Tab in the LTK app displays a scrollable feed of engaging and stylish videos from various Creators.",
    ).value,
    title: t("Watch Creators near you").value,
    description: t("Get your daily dose of videos from Creators near you, in major cities, or by interest.").value,
    action: t("Watch now").value,
    // edit link functionality here https://dashboard.branch.io/quick-links/qlc/config/1446901049024816907?editing=true&v=latest&step=general
    cta: "https://ltk.app.link/XfJlJw8Y2Sb",
  },
]);

return { __sfc: true,t, items }
}

})